module.exports = __webpack_public_path__ + "static/media/3.5 Bellevois nach.579aa63d.jpg";